import React from 'react'
import st from './CallItem.module.scss'
import { formatDate } from 'helpers/date'
import { calculateDuration } from 'helpers'
import { ReactComponent as CallOutgoing } from 'components/CRM/UI/icons/call-outgoing.svg'
import { ReactComponent as CallIncoming } from 'components/CRM/UI/icons/call-incoming.svg'
import { ReactComponent as PlayIcon } from 'components/CRM/UI/icons/play-icon.svg'
import { ReactComponent as DownloadIcon } from 'components/CRM/UI/icons/download-icon.svg'
import { ReactComponent as TranscriptionIcon } from 'components/CRM/UI/icons/transcription.svg'

const CallItem = ({
  call,
  index,
  activeCallId,
  toggleTranscription,
  translate,
}) => {
  const getEventText = () => {
    const from = call.from_name || call.from_number || 'Unknown'
    const to = call.to_name || call.to_number || 'Unknown'
    return `${from} to ${to}`
  }

  const getResultText = () => {
    if (call.status === 'ANSWER') {
      return translate?.status_conversation
    } else if (call.status !== 'ANSWER' && !call.is_outgoing) {
      return translate?.status_call_back
    } else if (
      call.status === 'NOANSWER' ||
      'BUSY' ||
      'CANCEL' ||
      'CONGESTION' ||
      ('CHANUNAVAIL' && call.is_outgoing)
    ) {
      return translate?.status_didnt_reach
    }
    return 'Unknown'
  }

  const getResultClass = () => {
    if (call.status === 'ANSWER') {
      return st.resultConversation
    } else if (call.status !== 'ANSWER' && !call.is_outgoing) {
      return st.resultCallBack
    } else if (call.status === 'NOANSWER' && call.is_outgoing) {
      return st.resultDidntReach
    }
    return ''
  }

  const baseLink = () => {
    const envVar = process.env.REACT_APP_CRM_BACKEND_DOMAIN
    return envVar
      ? `https://${process.env.REACT_APP_CRM_BACKEND_DOMAIN}`
      : 'https://exams.crm.phoenix24.io'
  }

  const isActive = activeCallId === call.id

  return (
    <>
      <div
        className={`${st.flexRow} ${index % 2 === 0 ? st.colorBg : ''} ${isActive ? st.highlightedRow : ''}`}
      >
        <div className={`${st.flexColumn} ${st.call} ${st.date}`}>
          {formatDate(call.started_at)}
        </div>
        <div className={`${st.flexColumn} ${st.call} ${st.eventTextBlock}`}>
          <div className={`${st.eventText}`}>
            {call.is_outgoing ? <CallOutgoing /> : <CallIncoming />}
            {getEventText()}
          </div>
        </div>
        <div className={`${st.flexColumn} ${st.call} ${st.resultBlock}`}>
          <div className={`${getResultClass()} ${st.result}`}>
            <span /> {getResultText()}
          </div>
        </div>
        <div className={`${st.flexColumn} ${st.call} ${st.duration}`}>
          {calculateDuration(call.answered_at, call.finished_at)}
        </div>
        <div className={`${st.flexColumn} ${st.call}  ${st.record}`}>
          {call.status === 'ANSWER' &&
            call.voice_record &&
            call.voice_record.file && (
              <div className={st.audioButtons}>
                <div>
                  <a
                    href={baseLink() + call.voice_record.file}
                    download
                    target='_blank'
                    rel='noopener noreferrer'
                  >
                    <PlayIcon />
                  </a>
                </div>
                <div>
                  <a
                    href={baseLink() + call.voice_record.file}
                    download
                    target='_blank'
                    rel='noopener noreferrer'
                  >
                    <DownloadIcon />
                  </a>
                </div>
                {call?.voice_record?.transcription && (
                  <div onClick={() => toggleTranscription(call.id)}>
                    <TranscriptionIcon
                      className={`${isActive ? st.highlightedIcon : ''}`}
                    />
                  </div>
                )}
              </div>
            )}
        </div>
      </div>
      {isActive && (
        <div className={`${st.transcription} ${isActive ? st.active : ''}`}>
          {call?.voice_record?.transcription}
        </div>
      )}
    </>
  )
}

export default CallItem
